import { render, staticRenderFns } from "./CekAlacakForm.vue?vue&type=template&id=0a48e33d"
import script from "./CekAlacakForm.vue?vue&type=script&lang=ts"
export * from "./CekAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports